import React, { useState, useEffect } from 'react';
import { TabMenu } from 'primereact/tabmenu';
import { Dialog } from 'primereact/dialog';
import { useNavigate, useLocation } from "react-router-dom";
import OrderService from '../components/service/OrderService';

const NavMenu = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [showReleaseNotes, setShowReleaseNotes] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  let items = [
   
  ];

  const handleLogout = () => {
    localStorage.removeItem('token'); // Remove the JWT token
    localStorage.removeItem('refreshToken'); // Remove the refresh token
    setIsAuthenticated(false); // Update authentication state
    navigate('/login'); // Redirect to the login page
  };
  


  if (isAuthenticated) {
    items.push(
      { label: "Orders", icon: "pi pi-fw pi-list", url: "/BakingStudioManager" },
      // { label: "Kitchen – Bakers", icon: "pi pi-fw pi-apple", url: "/BakingStudioManager/kitchen/bakers" },
      // { label: "Kitchen – Decorators", icon: "pi pi-fw pi-palette", url: "/BakingStudioManager/kitchen/decorators" },

      { label: "WeeklySummary", icon: "pi pi-fw pi-home", url: "/BakingStudioManager/weekly-summary" },
      //{ label: "Customers", icon: "pi pi-fw pi-users", url: "/BakingStudioManager/customers" },
      { label: "Employee Tasks", icon: "pi pi-fw pi-check", url: "/BakingStudioManager/employee-tasks" },
      { label: "Production List", icon: "pi pi-fw pi-file", url: "/BakingStudioManager/production-list" },
      // { label: "Bakery & Customer Analytics", icon: "pi pi-fw pi-chart-bar", disabled: true},
      // { label: "Configure", icon: "pi pi-fw pi-cog", url: "/BakingStudioManager/configure" },
      { label: 'Version', icon: 'pi pi-fw pi-info-circle', index: 5 },
      { label: "Logout", icon: "pi pi-fw pi-sign-out", action: handleLogout });
  }

  // Add an index to each item
  items = items.map((item, index) => ({
    ...item,
    index,
  }));

  useEffect(() => {
    const token = localStorage.getItem('token');
    setIsAuthenticated(!!token); // Set to true if token exists, else false

    // Set the initial active index based on the current location
    const activeItem = items.find(item => item.url === location.pathname);
    if (activeItem) {
      setActiveIndex(activeItem.index);
    }
  }, [location.pathname]);



  // Set the initial active index based on the current location
  useEffect(() => {
    const activeItem = items.find(item => item.url === location.pathname);
    if (activeItem) {
      setActiveIndex(activeItem.index);
    }
  }, [items, location.pathname]);

  const onTabChange = (e) => {
    const selectedItem = e.value;
    if (selectedItem.label === 'Version') {
      // Prevent navigation and show the modal instead
      setShowReleaseNotes(true);
    } else if (selectedItem.label === 'Logout') {
      // Handle logout
      selectedItem.action();
    } else {
      // Navigate normally
      setActiveIndex(selectedItem.index);
      navigate(selectedItem.url);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    const refreshToken = localStorage.getItem('refreshToken');
  
    if (!token && refreshToken) {
      // Try refreshing the token
      OrderService.refreshToken(refreshToken)
        .then(({ token, refreshToken: newRefreshToken }) => {
          localStorage.setItem('token', token);
          localStorage.setItem('refreshToken', newRefreshToken);
        })
        .catch(() => {
          localStorage.removeItem('token');
          localStorage.removeItem('refreshToken');
          navigate('/login');
        });
    }
  }, []);

  return (
    <div className="nav-menu">
      <TabMenu model={items} activeIndex={activeIndex} onTabChange={onTabChange} />
      <Dialog header="Release Notes" visible={showReleaseNotes} modal onHide={() => setShowReleaseNotes(false)}>
        <ReleaseNotes />
      </Dialog>
    </div>
  );
};

export default NavMenu;


const ReleaseNotes = () => (
  <div>
    <p><strong>Current</strong></p>
    <p>V1.260112</p>
    <p>1. Added Customer Analytics Section + Order browsing</p>
    <p>2. Added Advanced Filters to Orders section</p><br />
    <p><strong>Previous</strong></p> 
    <p>V1.250812</p>
    <p>1. Progress bar added to photo uploads</p>
    <p>2. Now supports PNG and JPG photos</p><br />
    <p>V1.250623</p>
    <p>1. Orders marked as pick-up with a delivery address no longer show as a "Delivery" order</p>
    <p>2. Configuration controls for Product Properties</p><br />
    <p>V1.250616</p>
    <p>1. Displays number of layers for all cakes</p> <br />
     <p>V1.250603</p>
    <p>1. Redesigned the upload/view/delete photo section to support drag and drop</p> <br />
    <p>V1.250404</p>
    <p>1. View All Invoices button added for manual linking</p> <br />
    <p>V1.250114</p>
    <p>1. Persistent login sessions</p> <br />
    <p>V1.250107</p>
    <p>1. Fixed issue with Production List showing the wrong date</p> <br />
    <p>V1.250102</p>
    <p>1. Fixed issue with "New Orders" causing a blank screen</p> 
    <p>2. Square Invoice Total now displays for each order</p> <br />
    <p>V1.241228</p>
    <p>1. Added username and password login</p>
    <p>2. Fixed "Delete" button issue</p>
    <p>3. Support for mobile view started</p>
    <p>4. App now hosted as web app</p>
    <p>5. Added support for uploading images</p>
    <p>6. Ability to view/navigate through images</p> <br />
    <p>V1.241123</p>
    <p>1. Loading robustness when page blanks out</p>
    <p>2. Fixed Resync Invoices</p> <br />
    <p>V1.241101</p>
    <p>1. Enhanced order deletion</p> <br />
    <p>V1.241009</p>
    <p>1. Fixed a formatting issue with COMP showing red</p>  <br />
    <p>2. Enhanced order deletion</p>
    <p>V1.240927</p>
    <p>1. Fixed a bug where orders were not loading properly</p>  <br />
    <p>V1.240924</p>
    <p>1. Fixed a bug where invoice status could not be found</p>  <br />
    <p>V1.240918</p>
    <p>1. Fixed a bug where invoice status could not be updated</p>
    <p>2. Improved logic in matching invoices</p> <br />
    <p>V1.240916</p>
    <p>1. Fixed a bug where order Due Date or Type could not be changed</p>
    <p>2. Invoice resync optimizations</p> <br />
    <p>V1.240913</p>
    <p>1. Fixed a bug where Pricing Field under Delivery Price allowed non-numerical values</p>
    <p>2. Fixed "Resync Invoices" and "Resync Customers" button </p>
    <p>3. Added enhancements to buttons disabled during resyncing/refreshing data</p>
    <p>4. Fixed an issue where invoices would not match if names were inconsistent due to case sensitivity</p>
    <p>5. Production List now includes invoice status</p>
    <p>6. Order item menu now stays above the order when scrolling</p><br />
    <p>V1.240517</p>
    <p>1. Production List styling updates</p>
    <p>2. Orders view now supports fully scrolling down the Order items - fixed the issue where you couldn't scroll and see the full invoice generated</p>
    <p>3. Orders, Production List, etc are now fetched by the date range instead of fetching all then filtering - faster loads</p>
    <p>4. Invoice Due Date selector was added for adding a date to copy and paste into the Square template</p><br />
    <p>V1.240511</p>
    <p>1. 'Cake Board Inscription' added to Order Form + Production List</p>
    <p>2. Only relevant order fields render when viewing orders in Read-Only mode</p>
    <p>3. Release notes modal added</p>
  </div>
);
